import { formatSecondsForReminder } from '../../Player/PlayerServices';
import { useEffect, useState } from 'react';
import { CustomReminder } from '../../Player/styles';

export default function RemindDuration({ player }: { player: HTMLVideoElement }) {
  const [watchedTime, setWatchedTime] = useState<number>(0);
  useEffect(() => {
    player.addEventListener('timeupdate', handleWatchedTime);
    return () => {
      player.removeEventListener('timeupdate', handleWatchedTime);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);

  const handleWatchedTime = () => {
    setWatchedTime(player.currentTime);
  };

  return (
    <CustomReminder variant='body2'>
      {!!player.duration && !!watchedTime && (
        <>
          {formatSecondsForReminder(watchedTime)} / {formatSecondsForReminder(player.duration)}
        </>
      )}
    </CustomReminder>
  );
}
